import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from 'src/app/core/services/settings.service';

@Pipe({
  name: 'themed',
  standalone: true,
})
export class ThemedPipe implements PipeTransform {
  host = location.host;

  logo?: string;
  loginScreen?: string;

  constructor(private settingsService: SettingsService) {
    let settings = this.settingsService.settings!;

    console.log("THEMED PIPE", {settings, host: this.host})

    const s = settings?.data.find((e) => e.url === this.host);
    this.loginScreen = s?.loginScreen;
    this.logo = s?.logo;
    // if there is the "primary color", set it to the document
    setTimeout(() => {
      console.log("THEMED PIPE - Setting color", {s, pc:s?.primaryColor})
      if (s?.primaryColor) {
        // set to the body
        document.body.style.setProperty(
          '--color-primary-30',
          s.primaryColor
        );
      }
      
    }, 0);
  }

  transform(defaultValue: string, type: 'logo' | 'loginScreen'): string {
    const themedValue = this[type];

    return themedValue ?? defaultValue;
  }
}
